// extracted by mini-css-extract-plugin
var _1 = "f80up4zu";
var _2 = "UnQ8up5n";
var _3 = "ohU4j_op";
var _4 = "mxMukHJw";
var _5 = "QJJvCH9l";
var _6 = "GGD9OLXB";
var _7 = "nSzgNWhJ";
var _8 = "dzZYqn08";
var _9 = "sEOvJlaY";
var _a = "Oz9462DU";
var _b = "aBhPBUHP";
var _c = "iI3brDaG";
var _d = "jzKvS_pq";
var _e = "BpBlpl71";
export { _1 as "backBtn", _2 as "card", _3 as "error", _4 as "input", _5 as "label", _6 as "logoMark", _7 as "logoRow", _8 as "logoText", _9 as "page", _a as "submitBtn", _b as "subtitle", _c as "success", _d as "switchBtn", _e as "switchRow" }
